<script setup>
import { ref, computed } from 'vue';
import Icon from 'next/icon/Icon.vue';
import { useSnakeCase } from 'dashboard/composables/useTransformKeys';
import { useMessageContext } from '../provider.js';
import GalleryView from 'dashboard/components/widgets/conversation/components/GalleryView.vue';

const props = defineProps({
  attachment: {
    type: Object,
    required: true,
  },
});

const showGallery = ref(false);
const thumbFailed = ref(false);

const { filteredCurrentChatAttachments } = useMessageContext();

const videoSrc = computed(() => {
  if (thumbFailed.value) {
    return props.attachment.dataUrl;
  }
  return props.attachment.thumbUrl || props.attachment.dataUrl;
});

const handleError = () => {
  if (
    !thumbFailed.value &&
    props.attachment.thumbUrl &&
    props.attachment.dataUrl
  ) {
    thumbFailed.value = true;
  }
};
</script>

<template>
  <div
    class="overflow-hidden contain-content rounded-xl cursor-pointer relative group"
    @click="showGallery = true"
  >
    <video
      :src="videoSrc"
      class="rounded-lg skip-context-menu max-w-80"
      :width="attachment.width"
      :height="attachment.height"
      muted
      playsInline
      @error="handleError"
    />
    <div
      class="absolute w-full h-full inset-0 p-1 flex items-center justify-center"
    >
      <div
        class="size-7 bg-n-slate-1/60 backdrop-blur-sm rounded-full overflow-hidden shadow-[0_5px_15px_rgba(0,0,0,0.4)]"
      >
        <Icon
          icon="i-teenyicons-play-small-solid"
          class="size-7 text-n-slate-12/80 backdrop-blur"
        />
      </div>
    </div>
  </div>
  <GalleryView
    v-if="showGallery"
    v-model:show="showGallery"
    :attachment="useSnakeCase(attachment)"
    :all-attachments="filteredCurrentChatAttachments"
    @error="onError"
    @close="() => (showGallery = false)"
  />
</template>
